export default __webpack_public_path__ + "static/media/register-dark.43b855db.svg";